'use strict';

angular.module('translations').factory('Translate',['$resource',
    function ($resource) {
        return $resource(
            'v1/projects/:mobileAppId/translations',
            {
                mobileAppId: '@mobileAppId'
            },
            {
                create : {
                    method: 'POST'
                },
                options: {
                    method: 'OPTIONS'
                }
            }
        );
    }
]);
